import Vue from 'vue'
import App from './App.vue'
//vue滑块
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
Vue.use(vueSwiper)
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
